module.exports = __webpack_public_path__ + "static/media/2025_dates.87cd6931.JPEG";